// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-resources-inventory.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-resources-inventory',
  title: 'Maintain AI resource inventory',
  description:
    'Confirm that an inventory of resources used to develop, deploy and operate AI systems is maintained and reviewed (ISO/IEC 42001 Cl. 7.1, Annex A.4.2–A.4.6). The inventory shall cover data resources, tooling, system and computing resources and the human resources (competencies, roles) needed. Review the inventory for completeness and for alignment with current AI systems in production and in development.',
  category: 'assets',
  scfIds: ['SCF-AIG-003'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'AI resource inventory is published and current' },
    { type: 'document-within-sla', description: 'Inventory review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
